export default __webpack_public_path__ + "static/weather--moon-3866bbc96e003321d4c06019e8fa531e.png";